<template>
  <div>
    <p class>Buscaste:</p>
    <b-row class="respuesta row col-lg-12 mx-auto mb-3 px-0 d-flex">
      <div class="px-0 mb-3 mr-md-3" :class="tamañoBuscaste">
        <b-row class="col-12 border-gris-claro p-0 ml-0">
          <div class="col-10 dkt d-md-inline mb-md-1 mt-md-1 px-2">
            <b-badge
              variant="light"
              class="m-1"
              :class="busqueda.filtro.length > pantalla ? 'truncate' : ''"
              v-for="busqueda in getBusquedasAplicadas"
              :key="busqueda.index"
            >
              {{formatearFiltro(busqueda)}}
              <span>
                <a @click="borrarFiltro(busqueda)" v-if="busqueda.eliminable">
                  <FontAwesomeIcon icon="times" class="ml-2" />
                </a>
              </span>
            </b-badge>
          </div>
          <!--<div class="d-inline ml-auto" style="z-index: 50; background-color: #6C757D;">-->
          <div class="d-inline ml-auto" style="background-color: #6C757D;">
            <button
              @click="reiniciarFiltros"
              class="btn btn-secondary rounded-0 order-md-1"
              type="button"
              v-b-tooltip.hover
              title="Borrar todos los filtros"
            >
              <FontAwesomeIcon icon="times" />
            </button>
          </div>
        </b-row>
      </div>
      <div
        class="col text-lg-right d-inline ml-0 mr-md-0 px-0 d-flex"
        v-if="mostrarFiltro || botonesVista"
      >
        <div class="buscador btn-group mb-lg-0 px-0 mr-md-2 d-flex" :class="tamañoTagsBotones">
          <div v-if="mostrarFiltro" class="px-0 flex-grow-1">
            <b-form-select
              class="custom-select multiple ordenar"
              v-model="criterioOrdenSeleccionado"
              @change="cambiarOrden"
              :disabled="vistaSeleccionada === 'lista'"
            >
              <option disabled value="null">Ordenar resultados</option>
              <option
                v-for="criterio in criteriosOrden"
                :key="criterio.index"
                :value="criterio.valor"
              >{{criterio.texto}}</option>
            </b-form-select>
          </div>
        </div>
        <div
          v-if="botonesVista"
          class="btn-group btn-group-toggle row ml-3 text-right d-none d-lg-inline-block"
        >
          <b-button
            class="tarj rounded-0"
            @click="cambiarVista('detalle')"
            variant="secondary"
            type="button"
            :pressed="vistaSeleccionada === 'detalle'"
            id="inputGroupFile03"
            v-b-tooltip.hover
            title="Vista en tarjetas"
          >
            <FontAwesomeIcon icon="th" />
          </b-button>
          <b-button
            class="tarj rounded-0"
            @click="cambiarVista('lista')"
            variant="secondary"
            type="button"
            :pressed="vistaSeleccionada === 'lista'"
            id="inputGroupFile02"
            v-b-tooltip.hover
            title="Vista en listado"
          >
            <FontAwesomeIcon icon="align-justify" />
          </b-button>
        </div>
      </div>
    </b-row>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faTimes,
  faTh,
  faAlignJustify,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import Busqueda from "@/utils/Busqueda.js";
import { mapGetters, mapActions } from "vuex";
library.add(faTimes, faTh, faAlignJustify);
export default {
  name: "TagsBusqueda",
  props: {
    filtro: {
      type: Boolean,
      default: false,
    },
    botonesVista: {
      type: Boolean,
      default: false,
    },
    vistaSeleccionada: {
      type: String,
    },
    criteriosOrden: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    FontAwesomeIcon,
  },
  data() {
    return {
      criterioOrdenSeleccionado: null,
      mostrarFiltro: this.filtro, //En caso de que decidan ocultar el filtro cuando este en ista lista
    };
  },
  watch: {
    getBusquedasAplicadas() {
      this.limpiarCriterioOrden();
    },
  },
  computed: {
    ...mapGetters(["getBusquedasAplicadas"]),
    tamañoBuscaste() {
      if (this.mostrarFiltro || this.botonesVista) {
        if (!this.mostrarFiltro) {
          return "col-lg-10";
        }
        return "col-lg-7";
      } else {
        return "col-lg-12";
      }
    },
    tamañoTagsBotones() {
      if (this.mostrarFiltro) {
        return "col-md-9";
      } else {
        return "col-md-4";
      }
    },
    pantalla() {
      if (screen.width < 1024) {
        return 35;
      } else {
        return 75;
      }
    },
  },
  methods: {
    ...mapActions(["setBusqueda"]),
    formatearFiltro(busqueda) {
      let filtroFormateado = busqueda.texto;
      if (busqueda.tipo === "REGION") {
        filtroFormateado = filtroFormateado.replace(/(Del|De)/, "");
        filtroFormateado = filtroFormateado.replace(/(DEL_|DE_)/, "");
        filtroFormateado = filtroFormateado.replace(/(_)/gi, " ");
      }
      if (busqueda.tipo === "GRATUIDAD") {
        switch (busqueda.filtro) {
          case "ADSCRITA_GRATUIDAD":
            filtroFormateado = "Adscrita a gratuidad";
            break;
          case "NO_ADSCRITA_GRATUIDAD":
            filtroFormateado = "No adscrita a gratuidad";
            break;
          default:
            break;
        }
      }
      return filtroFormateado;
    },
    borrarFiltro(filtro) {
      let filtrosAplicados = [...this.getBusquedasAplicadas];
      let indiceFiltro = filtrosAplicados.findIndex(
        (f) => f.tipo === filtro.tipo
      );
      if (indiceFiltro !== -1) {
        filtrosAplicados.splice(indiceFiltro, 1);
      }
      this.setBusqueda(filtrosAplicados);
    },
    cambiarOrden() {
      this.$emit("cambiarOrden", this.criterioOrdenSeleccionado);
    },
    cambiarVista(valor) {
      this.$emit("cambiarVista", valor);
    },
    reiniciarFiltros() {
      this.setBusqueda([]);
    },
    limpiarCriterioOrden() {
      this.criterioOrdenSeleccionado = null;
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/generales/paginas/TagsBusqueda.vue